export const dashboardKeys = {
	all: ['dashboards'] as const,
	/** Every dashboard visible in one project, with configs. `scope` = tenant. */
	list: (scope: string) => [...dashboardKeys.all, 'list', scope] as const,
	/** The same list without configs — id, title and type only. `scope` = tenant. */
	summaryList: (scope: string) => [...dashboardKeys.all, 'summaryList', scope] as const,
	/** Users and roles a dashboard can be shared with. `scope` = tenant. */
	shareOptions: (scope: string) => [...dashboardKeys.all, 'shareOptions', scope] as const,
}
